const ARROW_UP = `
<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.2764 13.1417C16.6019 12.8163 16.6019 12.2887 16.2764 11.9632L11.2764 6.96321C10.951 6.63778 10.4234 6.63778 10.0979 6.96321L5.09792 11.9632C4.77248 12.2887 4.77248 12.8163 5.09792 13.1417C5.42336 13.4672 5.95099 13.4672 6.27643 13.1417L10.6872 8.73098L15.0979 13.1417C15.4234 13.4672 15.951 13.4672 16.2764 13.1417Z" stroke="none"/>
</svg>`;

export default ARROW_UP;
